import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { UsersService } from '../services/user.service';

@Injectable()
export class RoleGuard  {

    constructor(
        private router: Router,
        private userService: UsersService
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        try {
            const user = await firstValueFrom(this.userService.getCurrentUser());
            if (user)
                return true;
        } catch (err) {
            console.log("Error fetching user.", err);
        }

        this.router.navigate(['/unauthorized']);
        return false;
    }
}
